import * as Q from "q";

export default class QPromiseCache<TResultType> {
    promiseCache: { [requestUri: string]: Q.Promise<TResultType> };

    constructor() {
        this.promiseCache = {};
    }

    get(requestUri: string, forceRefresh: boolean = false, data: any = null): Q.Promise<TResultType> {
        let stringifiedData = "";

        if (data) {
            stringifiedData = JSON.stringify(data);
        }

        const cacheString = `${requestUri.toLowerCase()}-${stringifiedData}`;
        let promise = this.promiseCache[cacheString];

        if (forceRefresh || !promise) {
            promise = Q<TResultType>($.ajax({
                type: 'GET',
                url: requestUri,
                data: data,
            }));

            this.promiseCache[cacheString] = promise;
        }

        return promise;
    }

    post(requestUri: string, forceRefresh: boolean = false, data: any = null): Q.Promise<TResultType> {
        let stringifiedData = "";

        if (data) {
            stringifiedData = JSON.stringify(data);
        }

        const cacheString = `${requestUri.toLowerCase()}-${stringifiedData}`;
        let promise = this.promiseCache[cacheString];

        if (forceRefresh || !promise) {
            promise = Q<TResultType>($.ajax({
                type: 'POST',
                url: requestUri,
                data: data
            }));

            this.promiseCache[cacheString] = promise;
        }

        return promise;
    }
}